import React from "react";
import Offers from "../components/Offers";
import { Offer } from "../interfaces/intefaces";

declare const offers: Offer[];

const OffersPage = () => {
    return (
        <>
            <Offers offers={offers} />
        </>
    );
};

export default OffersPage;
